enum LineItemChannelType {
  OOH = 'out_of_home', // Out of home
  DISPLAY_VIDEO = 'display_video', // Display & video
}

export default LineItemChannelType;
